import { Stack } from 'expo-router'
import { RewardsScreens } from '../screens'
import { SegmentDomainProvider } from '@/src/services/segment/SegmentDomainProvider'
import { Platform } from 'react-native'
import { mesaColorNames } from '@/src/common/theme'

export const RewardsLayout = () => (
  <SegmentDomainProvider domain="Rewards">
    <Stack
      screenOptions={{
        animation: 'none',
        headerShown: false,
        statusBarStyle: Platform.OS === 'android' ? 'dark' : undefined,
        contentStyle: {
          backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'],
        },
      }}
    >
      <Stack.Screen name={RewardsScreens.Rewards.name} />
      <Stack.Screen name={RewardsScreens.PointsLedger.name} options={{ animation: 'default' }} />
      <Stack.Screen
        name={RewardsScreens.PointsTransferInterstitial.name}
        options={{ animation: 'default' }}
      />
    </Stack>
  </SegmentDomainProvider>
)
